import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import { formatTimestamp } from "../../hooks/time-buckets";

export default function BarChartWidget({ data, granularity, color = "#6366f1", fullscreen }) {
    if (!data || data.length === 0) {
        return <div className="empty-chart">No data</div>;
    }

    return (
        <ResponsiveContainer width="100%" height={fullscreen ? "100%" : 200}>
            <BarChart data={data} isAnimationActive={false}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis
                    dataKey="timestamp"
                    tickFormatter={(ts) => formatTimestamp(ts, granularity)}
                    tick={{ fontSize: 11 }}
                    stroke="#94a3b8"
                />
                <YAxis tick={{ fontSize: 11 }} stroke="#94a3b8" />
                <Tooltip
                    labelFormatter={(ts) => new Date(ts).toLocaleString()}
                    formatter={(v) => [Number(v).toFixed(2), "Value"]}
                />
                <Bar dataKey="value" fill={color} radius={[4, 4, 0, 0]} isAnimationActive={false} />
            </BarChart>
        </ResponsiveContainer>
    );
}
